// Persona-led first-session greeting (coach-tooltip-system.md §5.1 rule 2). Pure
// text builder — no store/socket access — so both the auto-trigger (useSocket.ts,
// on the empty-state → first-session transition) and the manual replay ("?" in
// GearMenu/More, §5.4) render byte-identical copy from one place.

export function personaGreetingText(sessionName: string | null): string {
  const who = sessionName || 'your agent';
  return `Hey — I'm ${who}. Type below, or hold the mic to talk to me. I'll point things out as we go.`;
}
